import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import AddBlog from "../components/AddBlog";

const AddBlogPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        
        {/* Breadcrumb */}
        <Breadcrumb title='Add Blog' />

        <AddBlog />

      </MasterLayout>
    </>
  );
};

export default AddBlogPage;
